export default __webpack_public_path__ + "static/tech-protection-leading-ddc3dfba551c296491748331d42a0d1c.jpeg";